// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PUig","buttons":"Footer_buttons__2eD91"};